// extracted by mini-css-extract-plugin
module.exports = {"dgray":"#393e46","mgray":"#73767b","dsilver":"#acaeb0","msilver":"#c9cacc","white":"#eee","error":"#ff7171","warn":"#f8c073","success":"#a9ccad"};